import angular from 'angular';

import './events.styles.scss';

import WorkflowEventsController from './events.controller';

export default angular.module('autoboard.workflowEvents', [])
  .controller('WorkflowEventsController', WorkflowEventsController)
  .name;
